export default "__VITE_ASSET__683aa43d__"